<template>
	<joy-page :joyPageStatus="joyPageStatus">
		<van-cell title="个人近照"></van-cell>
		<div class="paddingXm">
			<van-uploader  v-model="imgList" :before-read="beforeRead"  :max-count="1"  />
		</div>
	</joy-page>
</template>

<script>
	export default{
		created() {
			this.loadData();
		},
		data(){
			return{
				
				joyPageStatus:'',
				listData:'',
				imgList:[],
			}
		},
		methods:{
			beforeRead(files){
				const _this=this;
				let reader = new FileReader();
				reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
				reader.onloadend = function () {
					lrz(this.result,{quality:0.5})
					.then(function (rst) {
						_this.$toast.loading({
						  duration: 0,       // 持续展示 toast
						  forbidClick: true, // 禁用背景点击
						  loadingType: 'spinner',
						  mask:true,
						  message: '图片上传中'
						});
						 try {
						 	_this.$axios.post('user/personalphoto', {"file":rst.base64}).then(res => {
						 		if (res.data.code == 200) {
									_this.imgList=[];
									_this.$toast.clear();
									_this.imgList.push({url:'http://img.jiarixiaodui.com/'+res.data.data.image});
									_this.$toast('上传成功');
									setTimeout(function() {
											_this.$router.go(-1)
									}, 1000);
						 		} else {
						 			_this.$toast(res.data.msg);
						 		}
						 		
						 	});
						 } catch (e) {
						 	console.log(e)
						 }
					}).catch(function (err) {
						console.log(err);
					});
				}
				return true;
			},
			loadData(){
				try{
					this.joyPageStatus = 'loading';
					this.$axios.get('user/info').then(res => {
						this.joyPageStatus = 'success';
						if(res.data.code==200){
							this.listData=res.data.data;
							this.imgList.push({url:'http://img.jiarixiaodui.com/'+this.listData.image});
						}else{
							this.$toast.fail(res.data.msg)
						}
					})
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
		},
		
	}
	
</script>

<style scoped="scoped">
</style>
